import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../App.css';
import mainLogo from '../assets/img/main_logo.png';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [hideNavbar, setHideNavbar] = useState(false);
  const location = useLocation();
  const lastScrollY = useRef(0);

  const toggleMenu = () => setIsOpen(!isOpen);
  useEffect(() => {
    const handleScroll = () => {
      const currentY = window.scrollY;
  
      if (currentY > lastScrollY.current + 5) {
        setHideNavbar(true);
      } else if (currentY < lastScrollY.current) {
        setHideNavbar(false);
      }
  
      lastScrollY.current = currentY;
    };
  
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path) => {
    if (path === "/services") {
      return location.pathname.startsWith("/services");
    }
    return location.pathname === path;
  };
  

  const navItems = [
    { path: "/", label: "Home" },
    { path: "/about", label: "About" },
    { path: "/services", label: "Services" },
    { path: "/gallery", label: "Gallery" },
    { path: "/FAQs", label: "FAQs" },
    { path: "/news", label: "News" },
    { path: "/booking", label: "Booking" },
  ];

  return (
    <nav className={`navbar ${isOpen ? 'navbar-open' : ''} ${hideNavbar ? 'navbar-hidden' : ''}`}>
      <div className="navbar-left">
        <img src={mainLogo} alt="Logo" className="navbar-logo" />
        <button className={`hamburger ${isOpen ? 'open' : ''}`} onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      <div className={`nav-links ${isOpen ? 'open' : ''}`}>
        {navItems.map(({ path, label }) => (
          <Link key={path} to={path} className={`nav-link ${isActive(path) ? 'active' : ''}`} onClick={() => setIsOpen(false)}>
            {label}
          </Link>
        ))}
      </div>
    </nav>
  );
};

export default Navbar;
